import { render, staticRenderFns } from "./CmsInsureContent.vue?vue&type=template&id=5480063c&scoped=true&"
import script from "./CmsInsureContent.vue?vue&type=script&lang=js&"
export * from "./CmsInsureContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480063c",
  null
  
)

export default component.exports